import { CognitoUserPool, ICognitoStorage } from 'amazon-cognito-identity-js';
import Amplify, { Auth } from 'aws-amplify';

import * as Constants from './constants';
import storageSync from './storage';

/**
 * @class
 * The cognito class provides helper methods for configuring and interacting
 * with cognito services
 */
export class Cognito {
  public static storage: ICognitoStorage = storageSync as ICognitoStorage;

  public static userPool = new CognitoUserPool({
    UserPoolId: Constants.USER_POOL_ID,
    ClientId: Constants.USER_POOL_CLIENT_ID,
    endpoint: Constants.USER_POOL_ENDPOINT,
    Storage: storageSync as ICognitoStorage
  });

  public static configure() {
    Auth.configure({
      userPoolId: Constants.USER_POOL_ID,
      userPoolWebClientId: Constants.USER_POOL_CLIENT_ID,
      endpoint: Constants.USER_POOL_ENDPOINT,
      storage: storageSync
    });

    Amplify.configure({ disabled: true });
  }
}

export default Cognito;
